import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberDisciplinaryStatusForm from '../../../components/forms/MemberDisciplinaryStatusForm';
import { useMemberDisciplinaryStatusById, useUpdateMemberDisciplinaryStatus } from '../../../hooks/useMemberDisciplinaryStatusApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { MemberDisciplinaryStatusDTO } from '../../../services/apiClient';

const MemberDisciplinaryStatusEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useMemberDisciplinaryStatusById(id!);
  const updateMutation = useUpdateMemberDisciplinaryStatus();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Disciplinary Statuses', href: '/admin/memberdisciplinarystatuses' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/memberdisciplinarystatuses');
    } catch (error) {
      console.error('Error updating MemberDisciplinaryStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/memberdisciplinarystatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.MemberDisciplinaryStatus.Edit'
    >
        {entityData ? (
          <MemberDisciplinaryStatusForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/memberdisciplinarystatuses')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default MemberDisciplinaryStatusEdit;